/**
 * Maintenance history export column headers (must match backend registry).
 */

export const MAINTENANCE_EXPORT_COLUMN_HEADERS = [
  'Type',
  'Complaint ID',
  'Device ID',
  'Device',
  'Department',
  'Title',
  'Status',
  'Severity',
  'Updated',
  'Performed By',
  'Hours',
  'Problem',
  'Closing Remarks',
  'Spare Parts',
  'Maintenance Type',
  'Description',
  'Due Date',
  'Next Due Date',
];

export const MAINTENANCE_EXPORT_EXCEL_DEFAULT_HEADERS = new Set([
  'Type',
  'Complaint ID',
  'Device',
  'Department',
  'Title',
  'Status',
  'Updated',
  'Performed By',
  'Hours',
  'Maintenance Type',
]);

/** Keep in sync with MAINTENANCE_EXPORT_EXCEL_DEFAULT_HEADERS (shared picker). */
export const MAINTENANCE_EXPORT_PDF_DEFAULT_HEADERS = new Set([
  ...MAINTENANCE_EXPORT_EXCEL_DEFAULT_HEADERS,
]);

export const createMaintenanceExportColumnsState = (format = 'excel') => {
  const defaults =
    format === 'pdf'
      ? MAINTENANCE_EXPORT_PDF_DEFAULT_HEADERS
      : MAINTENANCE_EXPORT_EXCEL_DEFAULT_HEADERS;
  return MAINTENANCE_EXPORT_COLUMN_HEADERS.reduce((acc, header) => {
    acc[header] = defaults.has(header);
    return acc;
  }, {});
};

export const getSelectedExportColumnHeaders = (exportColumns) =>
  Object.entries(exportColumns)
    .filter(([, enabled]) => enabled !== false)
    .map(([header]) => header);
